import React from 'react';
import { Link } from 'react-router-dom';
import { MDBInputGroup, MDBBtn, MDBCol, MDBInput } from 'mdbreact';
import NewsLetterSubFooter from '@Containers/NewsletterSub/newsLetterSubFooter';


export default function Footer(props) {
  const backToTopRef = React.createRef();

  function scrollFunction() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      document.getElementById('back-to-top').style.display = 'block';
    } else {
      document.getElementById('back-to-top').style.display = 'none';
    }
  }
  window.onscroll = () => {
    scrollFunction();
  };

  function backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  // Set cookie
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
  }

  // Get cookie
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let c of ca) {
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  // Accept/Decline
  function acceptCookies() {
    setCookie('cookieConsent', 'true', 365);
    const el = document.getElementById('cookie-popup');
    if (el) el.style.display = 'none';
  }

  function declineCookies() {
    setCookie('cookieConsent', 'false', 365);
    const el = document.getElementById('cookie-popup');
    if (el) el.style.display = 'none';
  }

  // Show popup if cookie is not set
  if (typeof window !== 'undefined') {
  setTimeout(() => {
    const el = document.getElementById('cookie-popup');
    if (!el) return;
    const consent = getCookie('cookieConsent');
    if (consent !== 'true') {
      el.style.display = 'block';
    }
  }, 100);
}



  return (
    <div>
      <div id="back-to-top" onClick={backToTop} ref={backToTopRef}>
        Back to Top
      </div>
      <footer className="page-footer footer mt-auto">
        <div className="container footer-container">
          <div className="row">

              <div className="col-6 col-md-4 col-lg-2"> {/*footer-link-col */}
                <ul className="list-unstyled">
                <li class="link-margin">
                  <Link to="/about-us" href="/about-us" className="footer-link">
                    About Us
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/store-locator" href="/store-locator" className="footer-link">
                    Store Locator
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/blog" href="/blog" className="footer-link">
                    Blog
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/oven-baked" href="/oven-baked" className="footer-link">
                    Why Baked
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/ingredients" href="/ingredients" className="footer-link">
                    Ingredients
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/careers" href="/careers" className="footer-link">
                    Careers
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/contact-us" href="/contact-us" className="footer-link">
                    Contact Us
                  </Link>
                </li>
                </ul>
              </div>

          
            <div className="col-6 col-md-4 col-lg-2 mx-lg-5">
              <ul className="list-unstyled">
                <li class="link-margin">
                  <Link to="/subscribe" href="/subscribe" className="footer-link">
                    Subscribe
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/newsletter" href="/newsletter" className="footer-link">
                    Newsletter
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/media" href="/media" className="footer-link">
                    Media
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/admin/main" className="footer-link">
                    Admin
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/sales/main" className="footer-link">
                    Sales Admin
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-4 col-lg-2 pr-lg-1">
              <ul className="list-unstyled">
              <li class="link-margin">
                  <Link to="/retail-training" href="/retail-training" className="footer-link">
                    Retail Training
                  </Link>
                </li>
                <li class="link-margin">
                  <Link
                    to="/terms-and-conditions"
                    href="/terms-and-conditions"
                    className="footer-link">
                    Terms and Conditions
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/privacy-policy" href="/privacy-policy" className="footer-link">
                    Privacy Policy
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/faq" href="/faq" className="footer-link">
                    FAQ
                  </Link>
                </li>
                <li class="link-margin">
                  <Link to="/site-map" href="/site-map" className="footer-link">
                  Site Map
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-md-10 col-lg-4 join-newsletter-section ml-lg-5">
              <div className="popup__p text-left footerText">Join Our Newsletter</div>
              <div> 
              <NewsLetterSubFooter outline={false} acceptAll={true} enableBtn={true} />
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-12 copyright-text-two">
                ® 2022 Lotus Pet Foods, All Rights Reserved
            </div>
          </div>
        </div>
      </footer>
      <div id="cookie-popup" style={{backgroundColor: '#333', color: 'white',padding: '10px 15px',textAlign: 'center',position: 'fixed',bottom: 0,left: 0,width: '100%',zIndex: 9999,borderTop: '1px solid #e74c3c',display: 'none'}}>
        <p style={{ margin: 0, fontSize: '16px' }}>
          We use cookies to ensure the best experience on our website. By continuing to browse, you agree to our{' '}
          <a href="/privacy-policy" style={{ color: '#f1c40f' }}>Privacy Policy</a>.
        </p>
        <div style={{ marginTop: 10 }}>
          <button onClick={acceptCookies} style={{ backgroundColor: '#e74c3c', border: 'none', padding: '5px 15px', color: 'white', cursor: 'pointer', margin: '5px' }}>Accept</button>
          <button onClick={declineCookies} style={{ backgroundColor: '#e74c3c', border: 'none', padding: '5px 15px', color: 'white', cursor: 'pointer', margin: '5px' }}>Decline</button>
        </div>
      </div>   
    </div> 

  );
}


